import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivityView } from '../../../../../views/master-views/app.view/app.view.component';
import { Validators } from '@angular/forms';
import { ContractorRegistrationDecisionActivity } from 'src/app/models/activities/contractor-registration-decision-activity';
import { CalculatedValueDataEntity } from 'src/app/models/data-entities';
import { FormActivityInputViewComponent } from '../../form-activity-editor/form-activity-input/form-activity-input-view/form-activity-input-view.component';

@Component({
    selector: 'wm-contractor-registration-decision-activity-input',
    templateUrl: './contractor-registration-decision-activity-input.component.html',
    styleUrls: ['./contractor-registration-decision-activity-input.component.css'],
    standalone: false
})
export class ContractorRegistrationDecisionActivityInputComponent
  extends ActivityView
  implements OnInit {
    
  @ViewChild('formActivityInputView', { static: true }) formActivityInputViewCtl: FormActivityInputViewComponent;

  constructor() {
    super();
  }

  ngOnInit() {
    this.showNext.emit(true);

    const effectiveDate = this.activity.model
      .getEntities()
      .find(e => e.templateCode.includes('EFFECTIVE_DATE'));
    const status = this.activity.model
      .getEntities()
      .find(e => e.templateCode.includes('STATUS'));

    const validators = effectiveDate.getValidators();
    this.form.controls[status.templateCode].valueChanges.subscribe(
      newStatus => {
        const effectiveControl = this.form.controls[effectiveDate.templateCode];

        if (newStatus === 'Approved') {
          effectiveDate.isRequired = true;
          effectiveControl.setValidators(validators);
        } else if (newStatus === 'Denied') {
          effectiveDate.isRequired = false;
          const newValidators = validators.filter(
            v => v.toString() !== Validators.required.toString()
          );

          effectiveControl.setValidators(newValidators);
        }

        effectiveControl.updateValueAndValidity({ emitEvent: false});
      }
    );

    // // if the workflow designer wanted the expiration date to be hidden,
    // // then hide it
    // const activity = this.activity as ContractorRegistrationDecisionActivity;
    // if (activity.hideExpirationDate) {
    //   const expirationDate = activity.model
    //     .getEntities()
    //     .find(e =>
    //       e.templateCode.includes('EXPIRATION_DATE')
    //     ) as CalculatedValueDataEntity;
    //   expirationDate.visibleToUser = false;
    // }
  }

  async persistChildComponent?() {
    return this.formActivityInputViewCtl.persistChildComponent();
  }
}
